import React, { useEffect, useState } from 'react';

const StanCard = ({ title, location, price, area, rooms, type, date, images, onClick }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [isComponentReady, setIsComponentReady] = useState(false); // Kontrolišemo hover efekt
  const [isSmallScreen, setIsSmallScreen] = useState(false); // Kontrolišemo da li je ekran mali

  useEffect(() => {
    // Proveravamo širinu ekrana i postavljamo `isSmallScreen` na true za male ekrane
    const handleResize = () => {
      const screenWidth = window.innerWidth;
      setIsSmallScreen(screenWidth <= 768); // Ako je širina manja ili jednaka 768px, to je mali ekran
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Pokrećemo odmah pri učitavanju komponente

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsComponentReady(true);
    }, 300); // Dodajemo malo duže vreme

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 2500);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div
      className={`relative bg-gray-800 rounded-lg shadow-lg max-w-sm mx-auto pt-8 p-4 overflow-hidden border-2 border-pink-600 transition-opacity duration-500 ${
        (isHovered || isSmallScreen) && isComponentReady ? 'animate-card-glow' : ''
      } ${isComponentReady ? '' : 'opacity-0'}`} // Komponenta je stalno hoverovana na malim ekranima
      onMouseEnter={() => isComponentReady && setIsHovered(true)} // Hover samo kada je komponenta spremna
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
    >
      <div className="p-4 rounded-lg relative z-10">
        <div className="relative overflow-hidden rounded-lg"> {/* Ovde postavljamo overflow: hidden */}
          <img
            src={images[currentImageIndex]}
            alt={title}
            className={`w-full h-48 object-cover rounded-lg shadow-md transition-transform duration-500 ease-in-out ${
              isComponentReady && !isSmallScreen ? 'hover:scale-105' : ''
            }`} // Hover efekat slike je isključen na malim ekranima
          />
          <div
            className={`absolute inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center text-white text-center transition-opacity duration-300 ${
              (isHovered || isSmallScreen) ? 'opacity-100 animate-slide-up-fade-in' : 'opacity-0 animate-slide-down-fade-out'
            }`}
          >
            <p className="text-lg">{location}</p>
          </div>
        </div>

        <div className="p-4 mt-4 text-white">
          <div className="flex justify-between items-center mt-4 font-semibold">
            {/* Cena postaje roza kad je komponenta hoverovana */}
            <span className={`text-xl transition-colors duration-300 ease-in-out ${(isHovered || isSmallScreen) ? 'text-pink-500' : ''}`}>
              € {price}
            </span>
            <div className="text-sm">
              <span className="transition-transform duration-300 ease-in-out transform hover:scale-105">{area} m²</span>
              <span className="ml-2 transition-transform duration-300 ease-in-out transform hover:scale-105">{rooms} soba</span>
            </div>
          </div>
        </div>

        {/* Tip stana ispod cene postaje roza kad je hover */}
        <div className={`bg-gray-700 text-sm flex justify-between items-center px-4 py-2 rounded-lg mt-4 transition-colors duration-300 text-gray-300`}>
          <span className={`font-medium transition-colors duration-300 ${(isHovered || isSmallScreen) ? 'text-pink-500' : ''}`}>
            {type}
          </span>
          <div className="flex items-center">
            <span className="mr-2">{date}</span>
            <i className="fa fa-info-circle"></i>
          </div>
        </div>

        <span className="absolute top-2 left-2 bg-pink-600 text-white px-2 py-1 rounded-lg text-xs font-semibold uppercase transition-transform duration-300 ease-in-out transform hover:scale-110">
          {type}
        </span>
      </div>
    </div>
  );
};

export default StanCard;
